import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	heading: {
		id: 'service-management-adoption-nudges.invite-user-prompt.heading',
		defaultMessage: 'Teams can resolve 46% of customer issues in a day or less!',
		description:
			'Spotlight heading shown to a user on side navigation when "Invite team" item is present',
	},
	headingIssueTermRefresh: {
		id: 'service-management-adoption-nudges.invite-user-prompt.heading-issue-term-refresh',
		defaultMessage: 'Teams can resolve 46% of customer work items in a day or less!',
		description:
			'Spotlight heading shown to a user on side navigation when "Invite team" item is present',
	},
	description: {
		id: 'service-management-adoption-nudges.invite-user-prompt.description',
		defaultMessage: 'Invite more team members to resolve issues faster.',
		description:
			'Spotlight description shown to a user on side navigation when "Invite team" item is present',
	},
	descriptionIssueTermRefresh: {
		id: 'service-management-adoption-nudges.invite-user-prompt.description-issue-term-refresh',
		defaultMessage: 'Invite more team members to resolve work items faster.',
		description:
			'Spotlight description shown to a user on side navigation when "Invite team" item is present',
	},
	dismissButton: {
		id: 'service-management-adoption-nudges.invite-user-prompt.dismiss-button',
		defaultMessage: 'Dismiss',
		description: 'Text content to dismiss the spotlight.',
	},
	inviteButton: {
		id: 'service-management-adoption-nudges.invite-user-prompt.invite-button',
		defaultMessage: 'Invite agents',
		description: 'Text content to invite JSM agents.',
	},
	dismissButtonAriaLabel: {
		id: 'service-management-adoption-nudges.invite-user-prompt.dismiss-button-aria-label',
		defaultMessage: 'Dismiss message',
		description: 'Aria label for spotlight dismiss button.',
	},
	addPeopleButton: {
		id: 'service-management-adoption-nudges.invite-user-prompt.add-people-button',
		defaultMessage: 'Add people',
		description:
			'Button label to invite users to JSM. Clicking on the button opens up the modal where the users can invite other users with given permissions.',
	},
});
